import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";

export const keys = {
    all: ["drcx"],
    configuration: (groupID: number, configurationID: number) => [
        ...keys.all,
        "configuration", {
            groupID,
            configurationID
        }
    ],
    configurationLists: () => [
        ...keys.all,
        "configuration-list"
    ],
    configurationList: (
        groupID: number,
        isMyReports?: boolean,
        includeInaccessibleReports?: boolean,
        includeChildGroups?: boolean
    ) => [
            ...keys.configurationLists(),
            {
                groupID,
                isMyReports,
                includeInaccessibleReports,
                includeChildGroups
            }
        ],
    optionalColumns: (
        groupID: number
    ) => [
            ...keys.all,
            "optionalColumns", {
                groupID
            }
        ],
    availableObjects: (
        customerID: number,
        groupID: number,
        includeDescendentGroups: boolean,
        includeTankBatteries: boolean,
        offline: boolean
    ) => [
            ...keys.all,
            "availableObjects", {
                customerID,
                groupID,
                includeDescendentGroups,
                includeTankBatteries,
                offline
            }
        ],
    availableColumns: (
        groupID: number,
        objects: Array<IeLynxObject>,
        dataType: eLynxObjectTypeEnum
    ) => [
            ...keys.all,
            "availableColumns", {
                groupID,
                objects,
                dataType
            }
        ],
    availableRuleInstances: (
        groupID: number,
        objects: Array<IeLynxObject>
    ) => [
            ...keys.all,
            "availableRuleInstances", {
                groupID,
                objects
            }
        ],
    availableDeviceTypes: (
        groupID: number
        ) => [
                ...keys.all,
                "availableDeviceTypes", {
                    groupID
                }
            ]
    
};
